import type { Flow } from "@/router/types";
import { SCREENS } from "@/router/screens";

export const ASSIGNED_TO_CORE_SIGNED: Flow = {
  [SCREENS.DOWNLOAD_DOCUMENTS]: {
    next: () => SCREENS.SMS_CODE,
    back: () => null,
  },
  [SCREENS.SMS_CODE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => SCREENS.DOWNLOAD_DOCUMENTS,
  },
  [SCREENS.THANK_YOU]: {
    next: () => null,
    back: () => null,
  },
};
